// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2KjE1","footer":"ModalCreateQualiphyProcedure_footer__Mqe7X","additionData":"ModalCreateQualiphyProcedure_additionData__3TdIG"};